module.exports = __webpack_public_path__ + "img/hr-boiler-S-light.473025b7.png";